// =============================================================================
// Role-based access control (single source of truth for the web dashboard).
// Backend already enforces authorization; this gates the UI (nav + routes) so
// each role only sees what it can use.
//
// Roles: admin (everything), manager (operations, no system settings),
//        user = "Staff" (POS/orders/customers only — cashier-style).
// =============================================================================

export const ROLES = ["admin", "manager", "user"];

export const ROLE_LABELS = {
  admin: "Admin",
  manager: "Manager",
  user: "Staff",
};

// Route prefixes a MANAGER may NOT access (system-level settings — admin only).
const MANAGER_DENY = [
  "/system",              // business settings, in-house shop, SEO
  "/system-setup",
  "/third-party",         // payment gateways
  "/send-notification",
  "/push-notification-setup",
  "/pricing",
];

// Route prefixes a STAFF (user) member MAY access — everything else is blocked.
const STAFF_ALLOW = [
  "/dashboard",
  "/pos",
  "/orders",              // includes /orders/order-details
  "/customers",
];

const startsWithAny = (pathname, prefixes) =>
  prefixes.some((p) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p));

// Can the given role open the given route?
export function canAccess(role, pathname) {
  if (!role) return false;
  if (role === "admin") return true;
  if (role === "manager") return !startsWithAny(pathname, MANAGER_DENY);
  // user / staff
  return startsWithAny(pathname, STAFF_ALLOW);
}
